<template>
    <main>

    	<div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <div class="page-body" style="min-height: 900px;" v-if="fetcher.initialized">

            <div class="container-fluid">
                <h1 class="mb-8">{{ pageTitle }}</h1>

                <chart />

                <div class="row mb-5 mb-lg-5">

                    <div class="col-24 col-md-12 col-xxl-8 mb-0 mb-sm-6 mb-xxl-0">
                        <input type="text"
                               class="form-control form-control-list"
                               placeholder="Sök anställd, massör eller mottagning..."
                               v-model="settings.query.text"
                        >
                    </div>
                    <div class="col-24 col-md-12 col-xxl-8 d-none d-sm-flex justify-content-start align-content-start mb-6 mb-xxl-0">
                        <div class="me-3">
                            <datepicker-new
                                input-class="form-control form-control-list"
                                :clear-button="true"
                                clear-button-icon="fa fa-times"
                                placeholder="Från datum"
                                :language="former.datepicker.locale"
                                :use-utc="true"
                                :monday-first="true"
                                :format="former.formerDateFormat"
                                v-model="settings.query.treatment_at_from"
                            />
                        </div>
                        <datepicker-new
                            input-class="form-control form-control-list"
                            :clear-button="true"
                            clear-button-icon="fa fa-times"
                            placeholder="Till datum"
                            :language="former.datepicker.locale"
                            :use-utc="true"
                            :monday-first="true"
                            :format="former.formerDateFormat"
                            v-model="settings.query.treatment_at_to"
                        />
                    </div>
                    <div class="col-24 col-md-12 col-xxl-5 d-none d-sm-block">
                        <select class="form-select form-control-list" v-model="settings.query.workplace" v-if="show_employee_workplace_column">
                            <option :value="null">Arbetsplats</option>
                            <option :key="'w'+workplace.id" :value="workplace.id" v-for="workplace in workplaces">{{ workplace.title }}</option>
                        </select>
                    </div>

                    <div class="col-md-12 col-xxl-3 d-none d-md-flex justify-content-end align-content-start">
                        <button class="btn btn-outline-primary" @click="openExportModal()">Exportera</button>
                    </div>

                </div>

                <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
                    <div slot="item-row" slot-scope="props">
                        <list-item-row :treatment="props.item" :displayFrom="'list'" :show_employee_workplace_column="show_employee_workplace_column" />
                    </div>
                </list>

            </div>

        </div>

    </main>
</template>

<script>
import scrollMixin from '../../../shared/mixins/scrollMixin'
import lister from '../../../shared/mixins/lister'
import fetcher from '../../../shared/mixins/fetcher'

import chart from './chart'
import ListItemRow from './list-item-row'

export default {

    mixins: [
        scrollMixin,
        lister,
        fetcher
    ],

    components: {
        ListItemRow,
        chart
    },

    data () {
        return {
            pageTitle: 'Behandlingar',
            workplaces: [],
            show_employee_workplace_column: false,
            fetcher: {
                autoFill: [
                    'workplaces',
                    'show_employee_workplace_column'
                ]
            },

            settings: {
                url: '/data/treatments/list',
                query: {
                    text: '',
                    treatment_at_from: null,
                    treatment_at_to: null,
                    workplace: null
                },
                columns: [
                    { column: 'treatment_at', name: 'Datum', class: 'col-8 col-sm-4 col-lg-3', sortable: true, default: true },
                    { column: 'employee_name', name: 'Anställd', class: 'col-12 col-sm-6 col-lg-5', sortable: true },
                    { column: 'workplace_title', name: 'Arbetsplats', class: 'col-lg-4 d-none d-lg-flex', sortable: true },
                    { column: 'part_payment', name: 'Delbetalning', class: 'col-sm-5 col-lg-4 d-none d-sm-flex', sortable: false },
                    { column: 'location', name: 'Beh.plats', class: 'col-sm-5 col-lg-4 d-none d-sm-flex', sortable: false },
                    { column: 'clinic_name_person', name: 'Massör', class: 'col-lg-4 d-none d-lg-flex', sortable: true }
                ],
                bulk_actions: [],
                export_fields: [
                    { column: 'treatment_at', name: 'Behandlingsdatum' },
                    { column: 'employee_name', name: 'Anställd' },
                    { column: 'workplace_title', name: 'Arbetsplats' },
                    { column: 'location', name: 'Behandlingsplats' },
                    { column: 'is_internal', name: 'På mottagning' },
                    { column: 'is_external', name: 'På arbetsplatsen' },
                    { column: 'clinic.name_person', name: 'Massör' },
                    { column: 'part_payment_text', name: 'Delbetalning' }
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/data/treatments'
        }
    },

    methods: {
        fetcherSuccess (data) {
            if (!this.show_employee_workplace_column) {
                this.settings.columns = this.settings.columns.filter(c => c.column !== 'employee_workplace_title')

                // this.settings.columns[2].class = 'col-1' // ändrar part_payment klassen, då den nu har index 2
            }
        }
    }
}
</script>
